module.exports = __webpack_public_path__ + "static/Fabriga-Bold-04ee4174a6fab6c337af185b4fdebe4c.woff2";